<div class="ui vertical menu" [ngStyle]="contextMenuStyle" style="width: 10rem; z-index: 10;">
	<a *ngFor="let item of contextMenuItems" class="item" (click)="onContextMenuItemClick(item)">
		{{item.actionName}}
	</a>
</div>